import { PropertySearchResult } from '@propertypal/shared/src/types/propertySearch';
import React, { FunctionComponent } from 'react';
import { Text } from '../typography';
import { Container, LinkButton } from './AlternativeSearches.style';

interface Props {
  searchResult: PropertySearchResult;
  onClick: (term: string) => void;
}

const AlternativeSearches: FunctionComponent<Props> = (props) => {
  return (
    <Container>
      <Text fontWeight="bold">Try widening your criteria for searching for:</Text>

      {props.searchResult.expandedAlternativeSearches &&
        Object.keys(props.searchResult.expandedAlternativeSearches).map((key) => {
          return (
            <LinkButton key={key} onClick={() => props.onClick(key)}>
              {key}
            </LinkButton>
          );
        })}
    </Container>
  );
};

export default AlternativeSearches;
